
        import _47root_47e_45learning_45platform_47frontend_47node_modules_47_64nuxt_47ui_47dist_47runtime_47vue_47plugins_47head_46js from "/root/e-learning-platform/frontend/node_modules/@nuxt/ui/dist/runtime/vue/plugins/head.js"
import _47root_47e_45learning_45platform_47frontend_47node_modules_47_64nuxt_47ui_47dist_47runtime_47plugins_47colors_46js from "/root/e-learning-platform/frontend/node_modules/@nuxt/ui/dist/runtime/plugins/colors.js"
export default {
  install (app) {
    app.use(_47root_47e_45learning_45platform_47frontend_47node_modules_47_64nuxt_47ui_47dist_47runtime_47vue_47plugins_47head_46js)
    app.use(_47root_47e_45learning_45platform_47frontend_47node_modules_47_64nuxt_47ui_47dist_47runtime_47plugins_47colors_46js)
  }
}
        